import React, { createContext, useState, useContext } from 'react'
import { listTask, taskStatus, getRefresh, addRefresh } from "../Network/Repair" 
import dayjs from 'dayjs'
import Ping from '../asset/sound/ping.wav'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'

const RepairContext = createContext()

function useRepair(){
    var auto
    const notifyCx = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.repair_service
    const autoRefreshSecond = 5
    const [taskList, setTaskList] = useState([])
    const [taskCount, setTaskCount] = useState(0)
    const [isNew, setNew] = useState(false)
    var prevTasklistSize = 0
    
    const fetchTask = () =>{
        listTask("ALL", null, null, "", "", false,
            (data)=>{
                setTaskList(data)

                if(prevTasklistSize === 0){
                    prevTasklistSize = data.content.length
                }else if(data.content.length > prevTasklistSize){
                    setNew(true)
                    prevTasklistSize = data.content.length
                    notifyCx.showNotify(lang.new_task, lang.new_task_desc, 1)
                    playSound()
                }

                let content = data.content
                var createdCount = []
                content.map((item)=>{
                    if(item.status === taskStatus.CREATE
                        && dayjs(new Date()).diff(item.createdDate, 'minute') < 60){
                        createdCount.push(data)
                    }
                })
                setTaskCount(createdCount.length)
            },
            (error)=>{
            }
        )
    }

    const playSound = () =>{
        const audio = new Audio(Ping)
        audio.play()
    }

    const refreshStatus = () =>{
        getRefresh(
            (data)=>{
                if(data === ""){
                    addRefresh(false,
                        (callback)=>{
                        },
                        (error)=>{
                            console.log(error)
                        })
                }

                if(data.refresh === true){
                    fetchTask()
                }else{
                    setNew(false)
                }
            },
            (error)=>{
                console.log(error)
            }
        )
    }
    
    const autoFetchTask = () =>{
        auto = setInterval(()=>{
            refreshStatus()
        }, autoRefreshSecond * 1000)
    }

    const clearAutoFetchTask = () =>{
        setTaskCount(0)
        clearInterval(auto)
    }
    
    return { taskList, taskCount, fetchTask, autoFetchTask, clearAutoFetchTask, isNew, setNew }
}

function RepairProvider(props){
    const repair = useRepair()

    return(
        <RepairContext.Provider value={repair}>
            {props.children}
        </RepairContext.Provider>
    )
}

export { RepairProvider, RepairContext }